import { useAppDispatch, useAppSelector } from "features/hooks";
import { RootState } from "features/store";
import { setDataSWOTModelThreats } from "features/swotModel";
import { ChangeEvent, FC, FormEvent, useState } from "react";
import styles from "../SWOTForms.module.scss";

const SWOTModelTForm: FC = () => {
  const dispatch = useAppDispatch();
  const data: string = useAppSelector(
    (state: RootState) => state.swotModel.data.threats
  );
  const [value, setValue] = useState<string>(data);

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    dispatch(setDataSWOTModelThreats(value));
    alert("Đã lưu!");
  };

  return (
    <div className={styles.contentWrap}>
      <div className={styles.container}>
        <h3 className={styles.title}>
          <span className={styles.strong}>Nguy cơ</span> của tôi
        </h3>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.formControl}>
            <label className={styles.label}>
              Nguy cơ và thách thức mà bạn đang gặp và sẽ gặp phải?
            </label>
            <textarea
              className={styles.input}
              name="threats"
              onChange={handleChange}
              rows={25}
            >
              {value}
            </textarea>
          </div>
          <button type="submit" className={styles.btn}>
            Lưu lại
          </button>
        </form>
      </div>
    </div>
  );
};

export default SWOTModelTForm;
